import request from '@/router/axios'

export function fetchList (query) {
  return request({
    url: '/post/admin/posts/template/page',
    method: 'get',
    params: query
  })
}

export function getObj (id) {
  return request({
    url: `/post/admin/posts/template/${id}`,
    method: 'get'
  })
}

export function addObj (body) {
  return request({
    url: '/post/admin/posts/template',
    method: 'post',
    data: body
  })
}

export function putObj (body) {
  return request({
    url: '/post/admin/posts/template',
    method: 'put',
    data: body
  })
}

export function delObj (id) {
  return request({
    url: `/post/admin/posts/template/${id}`,
    method: 'delete'
  })
}
